<script lang="ts" setup>
import ValorumProLogo from "@/assets/images/brand/valorum-pro-logo.png";

const faxFormUrl = "/forms/ValorumPRO_Enrollment_Form.pdf";
const faxFormFilename = "ValorumPRO_Enrollment_Form.pdf";
</script>

<template>
  <div class="registration-shell">
    <v-container class="registration-header-container">
      <div class="registration-header-bar"></div>

      <div class="registration-header">
        <div class="registration-header__brand">
          <img :src="ValorumProLogo" alt="ValorumPRO" class="registration-header__logo" />
        </div>

        <div class="registration-header__fax">
          <span>
            If you prefer to fax in your application, click below for the fax form.
          </span>

          <v-btn
            color="#1588A0"
            dark
            :href="faxFormUrl"
            :download="faxFormFilename"
          >
            Download the fax form
          </v-btn>
        </div>
      </div>
    </v-container>

    <router-view />
  </div>
</template>

<style>
.registration-shell {
  min-height: 100vh;
  padding: 32px 12px 56px;
  background: #f5f7fb;
}

.registration-header-container {
  max-width: 1100px;
  padding: 0 !important;
  margin: 0 auto 16px;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 18px rgba(14, 35, 56, 0.12);
}

.registration-header-bar {
  height: 10px;
  background: #1588a0;
  width: 100%;
}

.registration-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: 26px 42px;
}

.registration-header__brand {
  flex: 0 0 auto;
}

.registration-header__logo {
  display: block;
  width: min(310px, 42vw);
  height: auto;
}

.registration-header__fax {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  max-width: 330px;
  text-align: right;
  color: #23364a;
  font-size: 0.95rem;
  line-height: 1.35;
}

@media (max-width: 760px) {
  .registration-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
  }

  .registration-header__logo {
    width: min(300px, 100%);
  }

  .registration-header__fax {
    align-items: flex-start;
    text-align: left;
  }
}
</style>
